<template>
<div class="chapter">
<div class="inner_page">
<p class="toca"><a id="ch00_fm05_cont"></a><a id="page_5"></a><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample"> <strong>INTRODUCTION BY ART SPIEGELMAN</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"> <strong>SERIES 1</strong> 1985</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"> <strong>SERIES 2</strong> 1985</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"> <strong>SERIES 3</strong> 1986</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"> <strong>SERIES 4</strong> 1986</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"> <strong>SERIES 5</strong> 1986</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"> <strong>AFTERWORD BY JOHN POUND</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"> <strong>INDEX</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_cont.vue?4580d29a